/**
 * Test IDs for QA automation.
 */
export const testIds = {
  viewOrganizationInfosGeneralInformation: "view-organization-infos-general-information",
  viewOrganizationInfosMaintenanceTasks: "view-organization-infos-maintenance-tasks",
} as const;
